import { useState } from "react"
import { Download } from "lucide-react"
import SocialShareBar from "@/components/public/social-share-bar"

export function CalculatorActionsBar({
  shareUrl,
  shareTitle,
  onDownloadPdf,
}: {
  shareUrl: string
  shareTitle: string
  onDownloadPdf: () => Promise<void>
}) {
  const [loading, setLoading] = useState(false)

  const handleDownload = async () => {
    setLoading(true)
    try {
      await onDownloadPdf()
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="flex items-center justify-between rounded-xl border border-stone bg-white p-3">
      <SocialShareBar url={shareUrl} title={shareTitle} />
      <button
        onClick={handleDownload}
        disabled={loading}
        className="inline-flex shrink-0 items-center gap-2 rounded-md border border-stone px-4 py-2 text-sm font-medium text-charcoal transition-colors hover:bg-stone/50 disabled:opacity-50"
      >
        <Download className="size-4" />
        {loading ? "Generating..." : "Download PDF"}
      </button>
    </div>
  )
}
